import React, { useEffect, useState, useRef } from "react";

const CountdownTimer = ({ intervalSec = 1, resetAfterSec, style, onReset, running = true }) => {
  const [count, setCount] = useState(0);
  const intervalRef = useRef();

  useEffect(() => {
    if (!running) {
      setCount(0);
      clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(() => {
      setCount((prev) => {
        if (resetAfterSec && prev + 1 >= resetAfterSec) {
          if (onReset) onReset();
          return 0;
        }
        return prev + 1;
      });
    }, intervalSec * 1000);
    return () => clearInterval(intervalRef.current);
  }, [intervalSec, resetAfterSec, onReset, running]);

  const minutes = Math.floor(count / 60);
  const seconds = count % 60;

  return (
    <p>
      Updated {minutes > 0 ? `${minutes} min ` : ""}
      {seconds} sec ago
    </p>
  );
};

export default CountdownTimer;